import { useDashboardSummary } from './lib/useDashboardSummary';
import React, { useState } from 'react';
import { Truck, Maximize2 } from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';
import ExpedicaoTotal from './ExpedicaoTotal';
import { useShippingData } from './lib/useShippingData';
import AnnualOperationalTotal from './components/dashboard/AnnualOperationalTotal';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5008';

const MiniChart = ({ color }) => {
  const data = Array.from({ length: 10 }, () => ({ val: Math.random() * 100 }));
  return (
    <div className="h-8 w-20 opacity-30">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Bar dataKey="val" fill={color} radius={[1, 1, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

  
function StatBox({ title, icon: Icon, color, border, dia, mes, maior, media, annual, year, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} px-5 py-5 min-h-[200px] rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      {/* Botão de Expansão */}
      <button
        onClick={onExpand}
        aria-label="Ver detalhes de expedição"
        className="absolute top-3 right-3 text-gray-600 hover:text-orange-400 transition-colors z-20"
      >
        <Maximize2 size={16} />
      </button>

      <div className={`flex items-center gap-2 mb-2 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={20} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-2">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Dia</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(dia).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <MiniChart color="#fb923c" />
      </div>

      <div className="border-t border-gray-800 pt-2">        
        <div className="flex justify-between items-center">
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Mês</p>
          <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
            R$ {Number(mes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>         
      </div>
      <AnnualOperationalTotal rows={annual.rows} loading={annual.loading} error={annual.error} metric="valorTotal" year={year} color={color} />
    </div>
  );
}


export default function Expedicao({ empresa = '', refreshSignal = 0, onOpenDashboard } = {}) {


  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, loading, error } = useDashboardSummary('/api/dashboard/expedicao', { empresa, refreshSignal });
  const year = new Date().getFullYear();
  const annual = useShippingData({ apiBaseUrl, company: empresa, refreshSignal, dataInicial: `${year}-01-01`, dataFinal: `${year}-12-31` });
  if (error) return <div role="alert" className="rounded border border-red-900 bg-[#161b22] p-4 text-xs text-red-300">{error}</div>;

  if (loading) return (
    <div className="bg-[#161b22] border-l-4 border-orange-500 px-5 py-5 rounded animate-pulse min-h-[200px]">
      <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
      <div className="h-8 bg-gray-800 rounded w-3/4"></div>
    </div>
  );

  return (
    <>
      <StatBox
        title="EXPEDIÇÃO"
        icon={Truck}
        color="text-orange-400"
        border="border-orange-500"
        dia={data?.totalExpedicaoDia || 0}
        mes={data?.totalExpedicao || 0}
        annual={annual}
        year={year}
        maior={data?.totalExpedicaomaior || 0}
        media={data?.MediamEntregue || 0}
        ///frete={data?.Totalfrete || 0}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <ExpedicaoTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
          onOpenDashboard={() => {
            setIsModalOpen(false);
            onOpenDashboard?.();
          }}
        />
      )}
    </>
  );
}
